import { gql } from "@outschool/ui-apollo";

import FollowedUserFragment from "./FollowedUserFragment";

export default gql`
  query FollowedTeachers {
    currentUser {
      uid
      followedUsers {
        ...FollowedUserFragment
      }
    }
  }
  ${FollowedUserFragment}
`;

export const followUserMutation = gql`
  mutation FollowUser(
    $userUid: ID!
    $referer: String
    $attribution: Attribution
  ) {
    followUser(
      userUid: $userUid
      referer: $referer
      attribution: $attribution
    ) {
      ...FollowedUserFragment
    }
  }
  ${FollowedUserFragment}
`;
